<template>
  <v-container fluid id="sms_client_history">
    <v-row>
      <v-col cols="12">
        <v-data-table
            :options.sync="pagination"
            :items="items"
            :loading="loading"
            :server-items-length="totalResults"
            :footer-props="{itemsPerPageOptions:[20,50,100,200]}"
            :headers="headers">
          <template v-slot:item="props">
            <tr>
              <td>{{getFormattedDate(props.item.dataWyslania)}}</td>
              <td>{{props.item.trescWyslana}}</td>
              <td>{{ props.item.trescOdebrana }}</td>
              <td>{{ props.item.ktoWyslal }}</td>
              <td>
                <v-btn color="primary" small class="mr-2" @click="editVisit(props.item.visitId)" v-if="$can('do','POKO_Wizyty_Edycja') && props.item.visitId > 0 && (!visitid || visitid == 0)" title="Pokaż wizyte">Pokaż wizyte</v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <VisitEditor :visitData="editorData" :visible="showVisitEditor" v-if="showVisitEditor" @close="showVisitEditor = false" :typywizyt="typywizyt"></VisitEditor>
  </v-container>
</template>

<script>
import * as dayjs from "dayjs";
import {clientService, therapistsService} from "@/services";
import swal from "sweetalert";

export default {
  name: "ClientSMS",
  components: {  VisitEditor: () => import('../visits/VisitEditor.vue')},
  props: ["clientid","visitid"],
  data() {
    return {
      totalResults: 0,
      selectedVisitId: 0,
      loading: true,
      items: [],
      pagination: {},
      editorData: null,
      showVisitEditor: false,
      enable_print: false,
      headers: [
        {text: 'Data i godzina smsa', sortable: false, align: 'left', value: 'dataWyslania'},
        {text: 'Treść wysłana', sortable: false, align: 'left', value: 'trescWyslana'},
        {text: 'Treść odebrana', sortable: false, align: 'left', value: 'trescOdebrana'},
        {text: 'Kto wysłał', sortable: false, align: 'left', value: 'ktoWyslal'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      typywizyt: []
    }
  },
  mounted() {
    this.getAllTypyWizyt()
  },
  methods: {
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      })
    },
    getAllTypyWizyt() {
      therapistsService.GetWszystkieTypyWizyt().then(result => {
        this.typywizyt = result.data.result
      }).catch(() => {
        this.error("Nie można pobrać typów wizyt terapeutów.");
      })
    },
    requestsSMSHistory() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination

      var req = clientService.getAllSMS({  SkipCount: (page-1)*itemsPerPage, MaxResultCount: itemsPerPage, ClientID: this.clientid, visitId: this.visitid })

      return req.catch(() => {
        this.showError("Błąd pobierania historii SMS klienta");
        this.loading = false;
      });
    },
    getFormattedDate(val)
    {
      let dj = dayjs(val)
      if(dj != null)
      {
        return dj.format("DD-MM-YYYY HH:mm")
      }
      else
      {
        return val
      }
    },
    editVisit(id)
    {
      this.showVisitEditor = true
      this.editorData = { Id: id }

    },
  },
  watch: {
    pagination: {
      handler() {
        this.requestsSMSHistory().then(data=> {
          this.items = data.data.result.items,
              this.totalResults = data.data.result.totalCount
          this.loading = false
        })
      },
      deep: true
    }
  }
}
</script>

